export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_fabricExpenseNo') || '面料请款单号',
    field: 'fabricExpenseNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_status') || '单据状态',
    field: 'fabricExpenseStatus',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricExpenseStatus' },
  },
  {
    title: that.$l('INDEX.table_label_salesPersonName') || '申请人',
    field: 'salesPersonName',
    width: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_saleDepName') || '申请人部门',
    field: 'saleDepName',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_archiveDate') || '申请日期',
    field: 'archiveDate',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_expensePayerName') || '付款公司',
    field: 'expensePayerName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_currencyAmount') || '请款金额',
    field: 'currencyAmount',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.table_label_currencyUnit') || '货币单位',
    field: 'currencyUnitText',
    minWidth: 96,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_rmbAmount') || '人民币金额',
    field: 'rmbAmount',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.table_label_costDepName') || '分摊部门',
    field: 'costDepName',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '费用客户',
    field: 'custName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_customerOrderNo') || '客户订单号',
    field: 'custOrderNo',
    minWidth: 140,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_expenseType') || '财务费用',
    field: 'expenseTypeText',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_remark') || '付款用途',
    field: 'remark',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_description') || '付款说明',
    field: 'description',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_notes') || '备注',
    field: 'notes',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scmName') || '供应商',
    field: 'scmName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_paymentMethod') || '付款方式',
    field: 'paymentMethodText',
    minWidth: 110,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_bankName') || '开户银行',
    field: 'bankName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_bankAccountName') || '账户名称',
    field: 'bankAccountName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_bankAccountNo') || '银行账号',
    field: 'bankAccountNo',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
